import React, { useEffect } from 'react';

import ModalWithTabs, {
  ModalTabs,
  ModalTabList,
  ModalTab,
  ModalTabPanels,
  ModalTabPanel
} from '@strava/ui/ModalWithTabs';
import { t } from '../../utils/invite-friends-utils';
import styles from './InviteFriendsModal.scss';
import { useInviteFriendsContext } from '../../state/InviteFriendsContext';
import {
  CLEAR_ALERT,
  CHANGE_TAB,
  CLOSE_MODAL
} from '../../state/InviteFriends.actions';
import EmailTabContent from './components/EmailTabContent/EmailTabContent';
import FindFacebookFriends from '../../../friends/FindFacebookFriends';
import { INVITE_FRIENDS } from '../../../friends/utils/friendsConstants';

const InviteFriendsModal = () => {
  const { state, dispatch, track } = useInviteFriendsContext();
  const {
    isModalOpen,
    modalTabIndex,
    currentAthlete,
    fbAppId,
    fbVersion,
    locale
  } = state;

  useEffect(() => {
    track({
      action: 'screen_enter'
    });
  }, [track]);

  const handleTabsChange = (selectedTab) => {
    dispatch({ type: CHANGE_TAB, payload: { modalTabIndex: selectedTab } });
    dispatch({ type: CLEAR_ALERT });
    track({
      element: selectedTab === 0 ? 'email' : 'facebook',
      action: 'click'
    });
  };

  return (
    <ModalWithTabs
      isOpen={isModalOpen}
      onDismiss={() => dispatch({ type: CLOSE_MODAL })}
      title={t('modal.title')}
      aria-label={t('modal.aria-label')}
      data-cy="invite-friends-modal"
    >
      <ModalTabs index={modalTabIndex} onChange={handleTabsChange}>
        <ModalTabList className={styles.tabList}>
          <ModalTab>{t('modal.email.title')}</ModalTab>
          <ModalTab>{t('modal.facebook.title')}</ModalTab>
        </ModalTabList>
        <ModalTabPanels className={styles.tabPanels}>
          <ModalTabPanel>
            <EmailTabContent />
          </ModalTabPanel>
          <ModalTabPanel>
            <FindFacebookFriends
              track={track}
              currentAthlete={currentAthlete}
              source={INVITE_FRIENDS}
              fbApiProps={{
                appId: fbAppId,
                version: fbVersion,
                locale
              }}
              isVisible={modalTabIndex === 1}
            />
          </ModalTabPanel>
        </ModalTabPanels>
      </ModalTabs>
    </ModalWithTabs>
  );
};

export default InviteFriendsModal;
